import StatusIncidentRow from "@/v2-status-client/status/incident/StatusIncidentRow"
import type { IncidentGroup } from "@/v2-status-client/status/incident/status.incident.utils"

export type StatusIncidentGroupProps = {
  group: IncidentGroup
}

// One date-grouped block in the incidents timeline: heading
// (e.g. "Tuesday, Apr 27") and a list of rows underneath. Splitting
// the day group out of the section list keeps the section file
// itself purely structural.
function StatusIncidentGroup(props: Readonly<StatusIncidentGroupProps>) {
  const { group } = props
  return (
    <li className="flex flex-col gap-1.5 border-b border-border/60 pb-3 last:border-b-0 last:pb-0">
      <h3 className="m-0 text-xs font-semibold uppercase tracking-wide text-muted-foreground">
        {group.dateLabel}
      </h3>
      <ul className="flex flex-col list-none p-0 m-0">
        {group.entries.map((i) => (
          <StatusIncidentRow key={i.id} incident={i} />
        ))}
      </ul>
    </li>
  )
}

export default StatusIncidentGroup
